import authHeader from "../../../authentication/authservices/auth-header";
import apiClient from "../../../http-common";

//Input/Output Audit
export const postInputOutputAudit = (saveObj) => {
    return apiClient.post(`/clinicalCareChart/saveInputOutputAudit`, saveObj, {
    headers: authHeader(),
  });
};

export const InputOutputAuditListing = (admissionId) => {
    return apiClient.get(`/clinicalCareChart/getInputOutputAuditTrail/${admissionId}`, {
    headers: authHeader(),
  });
};

//Care And Position
export const postCareAndPosition = (saveObj) => {
    return apiClient.post(`/clinicalCareChart/saveCPAudit`, saveObj, {
    headers: authHeader(),
  });
};

export const CareAndPositionListing = (admissionId) => {
    return apiClient.get(`/clinicalCareChart/getCPAuditTrail/${admissionId}`, {
    headers: authHeader(),
  });
};

//ISBAR Audit
export const postISBARAudit = (saveObj) => {
    return apiClient.post(`/clinicalCareChart/saveISBARAudit`, saveObj, {
    headers: authHeader(),
  });
};

export const ISBARAuditListing = (admissionId) => {
    return apiClient.get(`/clinicalCareChart/getISBARAuditTrail/${admissionId}`, {
    headers: authHeader(),
  });
};

//Bed Sore Audit
export const postBedSoreAudit = (saveObj) => {
    return apiClient.post(`/clinicalCareChart/saveBedSoreAudit`, saveObj, {
    headers: authHeader(),
  });
};

export const BedSoreAuditListing = (admissionId) => {
    return apiClient.get(`/clinicalCareChart/getBedSoreAuditTrail/${admissionId}`, {
    headers: authHeader(),
  });
};

//Lines
export const postLines = (saveObj) => {
    return apiClient.post(`/clinicalCareChart/saveLineAudit`, saveObj, {
    headers: authHeader(),
  });
};

export const LinesListing = (admissionId) => {
    return apiClient.get(`/clinicalCareChart/getLineAuditTrail/${admissionId}`, {
    headers: authHeader(),
  });
};